import { QueryClient, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { API_URL } from '../Utils/api';

export const useUserInfo = (token) => {

    const queryClient = new QueryClient({
        defaultOptions: {
            queries:{
                staleTime: 1000 *60*5,
                cacheTime: 1000 *60*30,
                refetchOnWindowFocus: false,
                retry: 1,
            }
        }
    })
    return useQuery({
        queryKey: ['user'],
        queryFn: async () => {
        const res = await axios.get(`${API_URL}/user_data`, {
            headers: { Authorization: `Bearer${token}` },
        });
        return res.data;
        },
        staleTime: 1000 * 60, 
        cacheTime: 1000 * 60 * 5,
    });
};
